<template>
    <div class="modal-tbf active modal-register">
        <div class="container-modal form-modal">
            <div class="container-holder">
                <div class="header-modal mb-0">
				    <div class="icon"><icon-download /></div>
				    <div class="title">Descarcă <span class="yellow">Proforma</span></div>
                    <div class="description">
                        De la butonul de mai jos poți descărca proforma în baza căreia poți să achiți prin ordin de plată. Factura proforma a fost emisă cu datele introduse de tine la pașii anteriori. Vom trimite și către adresa ta de e-mail acest document.
                        <br>
                        După confirmarea plății în contul bancar indicat pe document, îți trimitem pe e-mail datele de acces la curs, iar factura fiscală se trimite în Spațiul Privat Virtual e-Factura. Procesul acesta poate dura până la 72 de ore.
                        <br>
                        Poți să ne scrii la <a href="mailto:contact@tbf.ro">contact@tbf.ro</a> pentru orice nelămurire. Te vom ajuta cu plăcere în cel mai scurt timp posibil.
                    </div>
                </div>

                <div class="submit-form">
                    <button class="button-submit square" @click="downloadInvoice">
                        <div class="text">{{ $t('register_success.button-action-op') }}</div>
				        <div class="icon"><icon-download /></div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import IconDownload from "../Icons/Download"

export default {
	data(){
		return {
            arrayTranslations: [
                'register_success.title',
                'register_success.description',
                'register_success.button-action'
            ]
		}
	},
    components: {
        IconDownload
    },
    mounted() {
        axios.post('/get-proforma', {
        }).then(({data}) => {
        
        })
    },
	methods: {
        downloadInvoice() {
            axios.post('/get-proforma', {
            }).then(({data}) => {
                window.open(data.url, '_blank');
            })
        }
	}
}
</script>